import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import wasteProcessingIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getWasteProcessing44Totals } from "../../../../../apis/Product/WasteProcessingFlow44Api";

const WasteProcessing44Icon = () => (
  <img src={wasteProcessingIcon} alt="Waste Processing Icon" width={76} height={76} />
);

const WasteProcessing44Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalWasteProcessingItem, setTotalWasteProcessingItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getWasteProcessing44Totals({
        productId,
        setTotals: setTotalWasteProcessingItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener('refresh-waste-processing-44-totals', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-waste-processing-44-totals', handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`waste-processing-44-category ${className || ""}`}
      leftBoxProps={{
        icon: <WasteProcessing44Icon />,
        title: t("WASTE_PROCESSING_REUSE_RECYCLING_RECOVERY") || "Waste processing for reuse, recycling and/or recovery",
        description:
          t("WASTE_PROCESSING_REUSE_RECYCLING_RECOVERY_DESC") ||
          "Covers the operations needed to turn the waste into recoverable materials (e.g., sorting, shredding, cleaning). It stops when the material reaches the 'end-of-waste' state and can be recycled or reused.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_44") || "Total for Flow 44",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalWasteProcessingItem?.impact_totals || null,
        lastUpdated: totalWasteProcessingItem?.updated_at
          ? formatDate(totalWasteProcessingItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default WasteProcessing44Header;

